// constants/chainQuestions.js
// アンサーチェーン / パネルクイズ 問題データ

// ========================================
// 定数定義
// ========================================

// 問題タイプ
export const CHAIN_QUESTION_TYPE = {
  CHAIN: 'chain',   // アンサーチェーン（複数正解、順番に回答）
  PANEL: 'panel',   // パネルクイズ（各パネルに一意の正解）
};

// パネルタイプ
export const PANEL_TYPE = {
  IMAGE: 'image',           // 画像のみ
  IMAGE_TEXT: 'imageText',  // 画像+テキスト
  TEXT: 'text',             // テキストのみ
};

// パネル状態
export const PANEL_STATUS = {
  AVAILABLE: 'available',   // 選択可能
  ANSWERED: 'answered',     // 正解済み
};

// ゲームフェーズ
export const CHAIN_GAME_PHASE = {
  // 共通
  WAITING: 'waiting',       // 開始待ち
  COMPLETE: 'complete',     // 全問正解
  TIMEOUT: 'timeout',       // 時間切れ

  // アンサーチェーン用
  ANSWERING: 'answering',   // 回答中

  // パネルクイズ用
  PREVIEW: 'preview',       // パネル紹介（1枚ずつ表示）
  SELECT: 'select',         // パネル選択中
  ANSWER: 'answer',         // 選択したパネルに回答中
  RESULT: 'result',         // 結果表示
};

// レイアウト定義
export const PANEL_LAYOUTS = {
  '2x2': { rows: 2, cols: 2, total: 4 },
  '2x3': { rows: 2, cols: 3, total: 6 },
  '3x3': { rows: 3, cols: 3, total: 9 },
  '1x4': { rows: 1, cols: 4, total: 4 },
  '1x5': { rows: 1, cols: 5, total: 5 },
};

// ========================================
// アンサーチェーン問題（既存フォーマット）
// ========================================

/**
 * 問題フォーマット:
 * {
 *   id: string,                    // ユニークID
 *   category: string,              // カテゴリ
 *   difficulty: number,            // 難易度 1-5
 *   answerCount: number,           // 必要回答数 (5 or 10)
 *   prompt: string,                // 問題文
 *   answers: [                     // 正解リスト（必要数より多く登録可能）
 *     { text: string, reading: string }
 *   ]
 * }
 */

export const CHAIN_QUESTIONS = [
  // ===== 5問版 =====
  {
    id: 'chain5-1-001',
    category: '動物',
    difficulty: 1,
    answerCount: 5,
    prompt: '干支の動物を5つ答えろ！',
    answers: [
      { text: 'ねずみ', reading: 'ねずみ' },
      { text: '牛', reading: 'うし' },
      { text: '虎', reading: 'とら' },
      { text: 'うさぎ', reading: 'うさぎ' },
      { text: '龍', reading: 'りゅう' },
      { text: 'へび', reading: 'へび' },
      { text: '馬', reading: 'うま' },
      { text: '羊', reading: 'ひつじ' },
      { text: '猿', reading: 'さる' },
      { text: '鶏', reading: 'にわとり' },
      { text: '犬', reading: 'いぬ' },
      { text: 'いのしし', reading: 'いのしし' },
      { text: 'ドラゴン', reading: 'どらごん' },
      { text: '蛇', reading: 'へび' },
      { text: '子', reading: 'ねずみ' },
      { text: '丑', reading: 'うし' },
      { text: '寅', reading: 'とら' },
      { text: '卯', reading: 'うさぎ' },
      { text: '辰', reading: 'たつ' },
      { text: '巳', reading: 'み' },
      { text: '午', reading: 'うま' },
      { text: '未', reading: 'ひつじ' },
      { text: '申', reading: 'さる' },
      { text: '酉', reading: 'とり' },
      { text: '戌', reading: 'いぬ' },
      { text: '亥', reading: 'い' },
    ],
  },
  {
    id: 'chain5-1-002',
    category: '食べ物',
    difficulty: 1,
    answerCount: 5,
    prompt: 'マクドナルドのメニューを5つ答えろ！',
    answers: [
      { text: 'ビッグマック', reading: 'びっぐまっく' },
      { text: 'マックフライポテト', reading: 'まっくふらいぽてと' },
      { text: 'チキンマックナゲット', reading: 'ちきんまっくなげっと' },
      { text: 'マックシェイク', reading: 'まっくしぇいく' },
      { text: 'チーズバーガー', reading: 'ちーずばーがー' },
      { text: 'てりやきマックバーガー', reading: 'てりやきまっくばーがー' },
      { text: 'フィレオフィッシュ', reading: 'ふぃれおふぃっしゅ' },
      { text: 'マックグリドル', reading: 'まっくぐりどる' },
      { text: 'エッグマックマフィン', reading: 'えっぐまっくまふぃん' },
      { text: 'アップルパイ', reading: 'あっぷるぱい' },
      { text: 'マックフルーリー', reading: 'まっくふるーりー' },
      { text: 'ハンバーガー', reading: 'はんばーがー' },
      { text: 'ダブルチーズバーガー', reading: 'だぶるちーずばーがー' },
      { text: 'ポテト', reading: 'ぽてと' },
      { text: 'ナゲット', reading: 'なげっと' },
    ],
  },
  {
    id: 'chain5-1-003',
    category: 'スポーツ',
    difficulty: 1,
    answerCount: 5,
    prompt: 'オリンピック競技を5つ答えろ！',
    answers: [
      { text: '陸上', reading: 'りくじょう' },
      { text: '水泳', reading: 'すいえい' },
      { text: '体操', reading: 'たいそう' },
      { text: 'サッカー', reading: 'さっかー' },
      { text: 'バスケットボール', reading: 'ばすけっとぼーる' },
      { text: 'バレーボール', reading: 'ばれーぼーる' },
      { text: 'テニス', reading: 'てにす' },
      { text: '卓球', reading: 'たっきゅう' },
      { text: '柔道', reading: 'じゅうどう' },
      { text: 'レスリング', reading: 'れすりんぐ' },
      { text: 'ボクシング', reading: 'ぼくしんぐ' },
      { text: 'フェンシング', reading: 'ふぇんしんぐ' },
      { text: 'アーチェリー', reading: 'あーちぇりー' },
      { text: '射撃', reading: 'しゃげき' },
      { text: '馬術', reading: 'ばじゅつ' },
      { text: 'カヌー', reading: 'かぬー' },
      { text: 'ボート', reading: 'ぼーと' },
      { text: 'セーリング', reading: 'せーりんぐ' },
      { text: 'サーフィン', reading: 'さーふぃん' },
      { text: 'スケートボード', reading: 'すけーとぼーど' },
    ],
  },
  {
    id: 'chain5-1-004',
    category: '音楽',
    difficulty: 1,
    answerCount: 5,
    prompt: '楽器を5つ答えろ！',
    answers: [
      { text: 'ピアノ', reading: 'ぴあの' },
      { text: 'ギター', reading: 'ぎたー' },
      { text: 'バイオリン', reading: 'ばいおりん' },
      { text: 'ドラム', reading: 'どらむ' },
      { text: 'フルート', reading: 'ふるーと' },
      { text: 'トランペット', reading: 'とらんぺっと' },
      { text: 'サックス', reading: 'さっくす' },
      { text: 'クラリネット', reading: 'くらりねっと' },
      { text: 'ベース', reading: 'べーす' },
      { text: 'チェロ', reading: 'ちぇろ' },
      { text: 'ハープ', reading: 'はーぷ' },
      { text: 'オルガン', reading: 'おるがん' },
      { text: '太鼓', reading: 'たいこ' },
      { text: '三味線', reading: 'しゃみせん' },
      { text: '琴', reading: 'こと' },
    ],
  },
  {
    id: 'chain5-1-005',
    category: '乗り物',
    difficulty: 1,
    answerCount: 5,
    prompt: '乗り物を5つ答えろ！',
    answers: [
      { text: '車', reading: 'くるま' },
      { text: '電車', reading: 'でんしゃ' },
      { text: 'バス', reading: 'ばす' },
      { text: '飛行機', reading: 'ひこうき' },
      { text: '船', reading: 'ふね' },
      { text: '自転車', reading: 'じてんしゃ' },
      { text: 'バイク', reading: 'ばいく' },
      { text: 'タクシー', reading: 'たくしー' },
      { text: '新幹線', reading: 'しんかんせん' },
      { text: 'ヘリコプター', reading: 'へりこぷたー' },
      { text: 'トラック', reading: 'とらっく' },
      { text: '地下鉄', reading: 'ちかてつ' },
    ],
  },
  {
    id: 'chain5-2-001',
    category: '地理',
    difficulty: 2,
    answerCount: 5,
    prompt: 'G7の国を5つ答えろ！',
    answers: [
      { text: '日本', reading: 'にほん' },
      { text: 'アメリカ', reading: 'あめりか' },
      { text: 'イギリス', reading: 'いぎりす' },
      { text: 'フランス', reading: 'ふらんす' },
      { text: 'ドイツ', reading: 'どいつ' },
      { text: 'イタリア', reading: 'いたりあ' },
      { text: 'カナダ', reading: 'かなだ' },
    ],
  },
  {
    id: 'chain5-2-002',
    category: '季節',
    difficulty: 2,
    answerCount: 5,
    prompt: '春の七草を5つ答えろ！',
    answers: [
      { text: 'せり', reading: 'せり' },
      { text: 'なずな', reading: 'なずな' },
      { text: 'ごぎょう', reading: 'ごぎょう' },
      { text: 'はこべら', reading: 'はこべら' },
      { text: 'ほとけのざ', reading: 'ほとけのざ' },
      { text: 'すずな', reading: 'すずな' },
      { text: 'すずしろ', reading: 'すずしろ' },
    ],
  },
  {
    id: 'chain5-2-003',
    category: '曜日',
    difficulty: 1,
    answerCount: 5,
    prompt: '曜日を5つ答えろ！',
    answers: [
      { text: '月曜日', reading: 'げつようび' },
      { text: '火曜日', reading: 'かようび' },
      { text: '水曜日', reading: 'すいようび' },
      { text: '木曜日', reading: 'もくようび' },
      { text: '金曜日', reading: 'きんようび' },
      { text: '土曜日', reading: 'どようび' },
      { text: '日曜日', reading: 'にちようび' },
      { text: '月曜', reading: 'げつよう' },
      { text: '火曜', reading: 'かよう' },
      { text: '水曜', reading: 'すいよう' },
      { text: '木曜', reading: 'もくよう' },
      { text: '金曜', reading: 'きんよう' },
      { text: '土曜', reading: 'どよう' },
      { text: '日曜', reading: 'にちよう' },
    ],
  },
  {
    id: 'chain5-3-001',
    category: '歴史',
    difficulty: 3,
    answerCount: 5,
    prompt: '徳川将軍の名前を5人答えろ！',
    answers: [
      { text: '家康', reading: 'いえやす' },
      { text: '秀忠', reading: 'ひでただ' },
      { text: '家光', reading: 'いえみつ' },
      { text: '家綱', reading: 'いえつな' },
      { text: '綱吉', reading: 'つなよし' },
      { text: '家宣', reading: 'いえのぶ' },
      { text: '家継', reading: 'いえつぐ' },
      { text: '吉宗', reading: 'よしむね' },
      { text: '家重', reading: 'いえしげ' },
      { text: '家治', reading: 'いえはる' },
      { text: '家斉', reading: 'いえなり' },
      { text: '家慶', reading: 'いえよし' },
      { text: '家定', reading: 'いえさだ' },
      { text: '家茂', reading: 'いえもち' },
      { text: '慶喜', reading: 'よしのぶ' },
    ],
  },

  // ===== 10問版 =====
  {
    id: 'chain10-1-001',
    category: '都道府県',
    difficulty: 1,
    answerCount: 10,
    prompt: '日本の都道府県を10個答えろ！',
    answers: [
      { text: '東京', reading: 'とうきょう' },
      { text: '大阪', reading: 'おおさか' },
      { text: '北海道', reading: 'ほっかいどう' },
      { text: '沖縄', reading: 'おきなわ' },
      { text: '京都', reading: 'きょうと' },
      { text: '福岡', reading: 'ふくおか' },
      { text: '愛知', reading: 'あいち' },
      { text: '神奈川', reading: 'かながわ' },
      { text: '千葉', reading: 'ちば' },
      { text: '埼玉', reading: 'さいたま' },
      { text: '兵庫', reading: 'ひょうご' },
      { text: '広島', reading: 'ひろしま' },
      { text: '宮城', reading: 'みやぎ' },
      { text: '新潟', reading: 'にいがた' },
      { text: '静岡', reading: 'しずおか' },
      { text: '長野', reading: 'ながの' },
      { text: '岡山', reading: 'おかやま' },
      { text: '熊本', reading: 'くまもと' },
      { text: '鹿児島', reading: 'かごしま' },
      { text: '石川', reading: 'いしかわ' },
      { text: '富山', reading: 'とやま' },
      { text: '岐阜', reading: 'ぎふ' },
      { text: '三重', reading: 'みえ' },
      { text: '滋賀', reading: 'しが' },
      { text: '奈良', reading: 'なら' },
      { text: '和歌山', reading: 'わかやま' },
      { text: '鳥取', reading: 'とっとり' },
      { text: '島根', reading: 'しまね' },
      { text: '山口', reading: 'やまぐち' },
      { text: '香川', reading: 'かがわ' },
      { text: '愛媛', reading: 'えひめ' },
      { text: '高知', reading: 'こうち' },
      { text: '徳島', reading: 'とくしま' },
      { text: '佐賀', reading: 'さが' },
      { text: '長崎', reading: 'ながさき' },
      { text: '大分', reading: 'おおいた' },
      { text: '宮崎', reading: 'みやざき' },
      { text: '山形', reading: 'やまがた' },
      { text: '秋田', reading: 'あきた' },
      { text: '岩手', reading: 'いわて' },
      { text: '青森', reading: 'あおもり' },
      { text: '福島', reading: 'ふくしま' },
      { text: '山梨', reading: 'やまなし' },
      { text: '群馬', reading: 'ぐんま' },
      { text: '栃木', reading: 'とちぎ' },
      { text: '茨城', reading: 'いばらき' },
      { text: '福井', reading: 'ふくい' },
    ],
  },
  {
    id: 'chain10-2-001',
    category: '食べ物',
    difficulty: 2,
    answerCount: 10,
    prompt: '寿司ネタを10種類答えろ！',
    answers: [
      { text: 'まぐろ', reading: 'まぐろ' },
      { text: 'サーモン', reading: 'さーもん' },
      { text: 'いくら', reading: 'いくら' },
      { text: 'うに', reading: 'うに' },
      { text: 'えび', reading: 'えび' },
      { text: 'たまご', reading: 'たまご' },
      { text: 'いか', reading: 'いか' },
      { text: 'たこ', reading: 'たこ' },
      { text: 'あなご', reading: 'あなご' },
      { text: 'ほたて', reading: 'ほたて' },
      { text: 'はまち', reading: 'はまち' },
      { text: 'ぶり', reading: 'ぶり' },
      { text: 'あじ', reading: 'あじ' },
      { text: 'さば', reading: 'さば' },
      { text: 'ひらめ', reading: 'ひらめ' },
      { text: 'たい', reading: 'たい' },
      { text: 'かんぱち', reading: 'かんぱち' },
      { text: 'えんがわ', reading: 'えんがわ' },
      { text: 'ねぎとろ', reading: 'ねぎとろ' },
      { text: '中トロ', reading: 'ちゅうとろ' },
      { text: '大トロ', reading: 'おおとろ' },
      { text: 'かつお', reading: 'かつお' },
      { text: 'さんま', reading: 'さんま' },
      { text: 'いわし', reading: 'いわし' },
      { text: 'あわび', reading: 'あわび' },
      { text: 'かに', reading: 'かに' },
    ],
  },
  {
    id: 'chain10-3-001',
    category: '芸能',
    difficulty: 3,
    answerCount: 10,
    prompt: '嵐のシングル曲を10曲答えろ！',
    answers: [
      { text: 'A・RA・SHI', reading: 'あらし' },
      { text: 'Love so sweet', reading: 'らぶそーすいーと' },
      { text: 'Happiness', reading: 'はっぴねす' },
      { text: 'truth', reading: 'とぅるーす' },
      { text: 'Monster', reading: 'もんすたー' },
      { text: 'Believe', reading: 'びりーぶ' },
      { text: 'One Love', reading: 'わんらぶ' },
      { text: '明日の記憶', reading: 'あしたのきおく' },
      { text: 'Beautiful days', reading: 'びゅーてぃふるでいず' },
      { text: 'Troublemaker', reading: 'とらぶるめーかー' },
      { text: 'サクラ咲ケ', reading: 'さくらさけ' },
      { text: 'きっと大丈夫', reading: 'きっとだいじょうぶ' },
      { text: 'Wish', reading: 'うぃっしゅ' },
      { text: 'GUTS!', reading: 'がっつ' },
      { text: '青空の下、キミのとなり', reading: 'あおぞらのしたきみのとなり' },
    ],
  },
];

/**
 * 問題をランダムに1つ選択
 * @param {number} answerCount - 5 or 10
 * @param {number} difficulty - 難易度 1-5
 * @param {string[]} excludeIds - 除外するID
 * @returns {Object|null}
 */
export function pickRandomChainQuestion(answerCount, difficulty, excludeIds = []) {
  const candidates = CHAIN_QUESTIONS.filter(
    q => q.answerCount === answerCount &&
         q.difficulty === difficulty &&
         !excludeIds.includes(q.id)
  );

  if (candidates.length === 0) {
    // フォールバック: 難易度を無視
    const fallback = CHAIN_QUESTIONS.filter(
      q => q.answerCount === answerCount && !excludeIds.includes(q.id)
    );
    if (fallback.length === 0) return null;
    return fallback[Math.floor(Math.random() * fallback.length)];
  }

  return candidates[Math.floor(Math.random() * candidates.length)];
}

/**
 * 全問題を取得
 */
export function getAllChainQuestions() {
  return CHAIN_QUESTIONS;
}

// ========================================
// パネルクイズ問題
// ========================================

/**
 * パネル問題フォーマット:
 * {
 *   id: string,
 *   type: 'panel',
 *   category: string,
 *   difficulty: number,
 *   prompt: string,              // 問題文
 *   layout: '2x2' | '2x3' | '3x3' | '1x4' | '1x5',
 *   panelType: 'image' | 'imageText' | 'text',
 *   panels: [
 *     {
 *       id: number,              // パネル番号 (1から)
 *       image?: string,          // 画像URL (panelType: image/imageText)
 *       text?: string,           // テキスト (panelType: imageText/text)
 *       answer: string,          // 正解
 *       reading: string,         // 読み
 *     }
 *   ],
 *   previewDuration: number,     // プレビュー時の各パネル表示秒数
 *   answerTimeLimit: number,     // 回答制限時間（秒）
 * }
 */

export const PANEL_QUESTIONS = [
  // ===== テキストパネル問題 =====
  {
    id: 'panel-text-001',
    type: CHAIN_QUESTION_TYPE.PANEL,
    category: '漢字',
    difficulty: 1,
    prompt: '漢字の読み方を答えろ！',
    layout: '2x2',
    panelType: PANEL_TYPE.TEXT,
    panels: [
      { id: 1, text: '林檎', answer: 'りんご', reading: 'りんご' },
      { id: 2, text: '蜜柑', answer: 'みかん', reading: 'みかん' },
      { id: 3, text: '葡萄', answer: 'ぶどう', reading: 'ぶどう' },
      { id: 4, text: '檸檬', answer: 'れもん', reading: 'れもん' },
    ],
    previewDuration: 3,
    answerTimeLimit: 15,
  },
  {
    id: 'panel-text-002',
    type: CHAIN_QUESTION_TYPE.PANEL,
    category: '漢字',
    difficulty: 2,
    prompt: '難読漢字の読み方を答えろ！',
    layout: '2x3',
    panelType: PANEL_TYPE.TEXT,
    panels: [
      { id: 1, text: '海豚', answer: 'いるか', reading: 'いるか' },
      { id: 2, text: '海月', answer: 'くらげ', reading: 'くらげ' },
      { id: 3, text: '河馬', answer: 'かば', reading: 'かば' },
      { id: 4, text: '駱駝', answer: 'らくだ', reading: 'らくだ' },
      { id: 5, text: '海星', answer: 'ひとで', reading: 'ひとで' },
      { id: 6, text: '翡翠', answer: 'かわせみ', reading: 'かわせみ' },
    ],
    previewDuration: 3,
    answerTimeLimit: 15,
  },
  {
    id: 'panel-text-003',
    type: CHAIN_QUESTION_TYPE.PANEL,
    category: '漢字',
    difficulty: 3,
    prompt: '国名を漢字で表すとき、この漢字はどこの国？',
    layout: '3x3',
    panelType: PANEL_TYPE.TEXT,
    panels: [
      { id: 1, text: '亜米利加', answer: 'アメリカ', reading: 'あめりか' },
      { id: 2, text: '英吉利', answer: 'イギリス', reading: 'いぎりす' },
      { id: 3, text: '仏蘭西', answer: 'フランス', reading: 'ふらんす' },
      { id: 4, text: '独逸', answer: 'ドイツ', reading: 'どいつ' },
      { id: 5, text: '伊太利亜', answer: 'イタリア', reading: 'いたりあ' },
      { id: 6, text: '西班牙', answer: 'スペイン', reading: 'すぺいん' },
      { id: 7, text: '葡萄牙', answer: 'ポルトガル', reading: 'ぽるとがる' },
      { id: 8, text: '和蘭', answer: 'オランダ', reading: 'おらんだ' },
      { id: 9, text: '露西亜', answer: 'ロシア', reading: 'ろしあ' },
    ],
    previewDuration: 2,
    answerTimeLimit: 15,
  },

  // ===== 横並びテキストパネル問題 =====
  {
    id: 'panel-text-004',
    type: CHAIN_QUESTION_TYPE.PANEL,
    category: '略語',
    difficulty: 2,
    prompt: 'これらの略語は何の略？',
    layout: '1x4',
    panelType: PANEL_TYPE.TEXT,
    panels: [
      { id: 1, text: 'FBI', answer: '連邦捜査局', reading: 'れんぽうそうさきょく' },
      { id: 2, text: 'NASA', answer: 'アメリカ航空宇宙局', reading: 'あめりかこうくううちゅうきょく' },
      { id: 3, text: 'WHO', answer: '世界保健機関', reading: 'せかいほけんきかん' },
      { id: 4, text: 'UNESCO', answer: '国連教育科学文化機関', reading: 'こくれんきょういくかがくぶんかきかん' },
    ],
    previewDuration: 3,
    answerTimeLimit: 20,
  },

  // ===== 数字クイズ =====
  {
    id: 'panel-text-005',
    type: CHAIN_QUESTION_TYPE.PANEL,
    category: '雑学',
    difficulty: 2,
    prompt: 'この数字は何を表している？',
    layout: '2x2',
    panelType: PANEL_TYPE.TEXT,
    panels: [
      { id: 1, text: '47', answer: '都道府県の数', reading: 'とどうふけんのかず' },
      { id: 2, text: '88', answer: '四国八十八か所', reading: 'しこくはちじゅうはちかしょ' },
      { id: 3, text: '108', answer: '煩悩の数', reading: 'ぼんのうのかず' },
      { id: 4, text: '206', answer: '人体の骨の数', reading: 'じんたいのほねのかず' },
    ],
    previewDuration: 3,
    answerTimeLimit: 20,
  },
];

// ========================================
// ヘルパー関数
// ========================================

/**
 * パネル問題をランダムに1つ選択
 * @param {Object} options - オプション
 * @param {number} options.difficulty - 難易度 1-5
 * @param {string} options.layout - レイアウト ('2x2', '2x3', etc.)
 * @param {string} options.panelType - パネルタイプ
 * @param {string[]} options.excludeIds - 除外するID
 * @returns {Object|null}
 */
export function pickRandomPanelQuestion(options = {}) {
  const { difficulty, layout, panelType, excludeIds = [] } = options;

  let candidates = PANEL_QUESTIONS.filter(q => !excludeIds.includes(q.id));

  if (difficulty) {
    candidates = candidates.filter(q => q.difficulty === difficulty);
  }
  if (layout) {
    candidates = candidates.filter(q => q.layout === layout);
  }
  if (panelType) {
    candidates = candidates.filter(q => q.panelType === panelType);
  }

  if (candidates.length === 0) {
    // フォールバック: フィルタなし
    const fallback = PANEL_QUESTIONS.filter(q => !excludeIds.includes(q.id));
    if (fallback.length === 0) return null;
    return fallback[Math.floor(Math.random() * fallback.length)];
  }

  return candidates[Math.floor(Math.random() * candidates.length)];
}

/**
 * 全パネル問題を取得
 */
export function getAllPanelQuestions() {
  return PANEL_QUESTIONS;
}

/**
 * パネルの回答を検証
 * @param {Object} panel - パネルオブジェクト
 * @param {string} userAnswer - ユーザーの回答
 * @returns {boolean}
 */
export function validatePanelAnswer(panel, userAnswer) {
  if (!panel || !userAnswer) return false;

  const normalizedAnswer = userAnswer.toLowerCase().replace(/\s/g, '');
  const normalizedCorrect = panel.answer.toLowerCase().replace(/\s/g, '');
  const normalizedReading = panel.reading.toLowerCase().replace(/\s/g, '');

  return normalizedAnswer === normalizedCorrect ||
         normalizedAnswer === normalizedReading;
}

/**
 * パネルゲームの初期状態を作成
 * @param {Object} question - パネル問題
 * @returns {Object}
 */
export function createPanelGameState(question) {
  if (!question || question.type !== CHAIN_QUESTION_TYPE.PANEL) {
    return null;
  }

  return {
    questionId: question.id,
    phase: CHAIN_GAME_PHASE.PREVIEW,
    currentPreviewIndex: 0,
    selectedPanelId: null,
    panelStatuses: question.panels.reduce((acc, panel) => {
      acc[panel.id] = PANEL_STATUS.AVAILABLE;
      return acc;
    }, {}),
    answeredCount: 0,
    totalPanels: question.panels.length,
  };
}

/**
 * レイアウト情報を取得
 * @param {string} layoutKey - レイアウトキー ('2x2', etc.)
 * @returns {Object}
 */
export function getLayoutInfo(layoutKey) {
  return PANEL_LAYOUTS[layoutKey] || PANEL_LAYOUTS['2x2'];
}
